jQuery(document).ready(function($) {

    if ( $("#id_shootingDates").length ) {
        $("#id_shootingDates").flatpickr({
            mode: 'range',
            minDate: "today",
            maxDate: new Date().fp_incr(365) // 14 days from now
        });
        $("#id_shootingDates").prop('readonly', false);
    }

    $("#newPullRequest").on("click", function(e) {
        var quickPullFormWrap = $("#quickPullFormWrap");
        var quickPullFormMessage = $("#quickPullFormMessage");
        quickPullFormMessage.slideUp('slow', function() {
            quickPullFormWrap.slideDown();
        });
    });

});